export enum AccountType {
  Card = 'Card',
  Payment = 'Payment',
}
